import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { Spacing } from '../../../../enums/spacing'
import { getHeaderPadding as getFooterPadding } from '../../utils/getHeaderPadding'

interface TableFooterWrapperProps {
  expandable?: boolean
  selectable?: boolean
}

export const TableFooterWrapper = styled.footer<TableFooterWrapperProps>`
  display: flex;
  align-items: center;
  height: 56px;
  border-top: 1px solid ${Color.Grey950};
  border-bottom-right-radius: ${Spacing.S8};
  border-bottom-left-radius: ${Spacing.S8};
  background: ${Color.White};
  white-space: nowrap;

  ${({ expandable, selectable }) => getFooterPadding(selectable, expandable)};
`
